import {
  HeadingGroup,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
  ConfirmationBox,
  ModalLayout,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import useCategoryList from "./useCategoryList";
import UpdateCategory from "../UpdateCategory";
import Filter from "../Filter";
import Style from "../category.module.scss";
import { ImageCard } from "../../Global/ImageCard";

const CategoryList = () => {
  const {
    category,
    categoryState,
    activeId,
    currentPage,
    activeFilter,
    showCreateModal,
    paginationOptions,
    isFetching,
    isLoading,
    showDeleteModal,
    isEditData,
    imageData,
    showImageModal,
    filterShow,
    setFilterShow,
    handleClearClick,
    handleCreateClick,
    closeDeleteModal,
    handlePagination,
    handlePageSize,
    refetch,
    handleSort,
    handleSearch,
    handleCategoryDataEditClick,
    closeModal,
    deleteCategoryDataClick,
    getRow,
    deleteCategory,
    tableFields,
    hasCreatePermission,
    hasEditPermission,
    hasViewPermission,
    hasDeletePermission,
  } = useCategoryList();

  return (
   
        <>
          <HeadingGroup
            title={"Category"}
            buttonTitle={hasCreatePermission ?? false ? "Add New" : ""}
             extraClassName={`pro-mb-4`}
            handleClick={handleCreateClick}
          />
            <div className="col-12 pro-pb-6">
              <SearchFilters
                activeFilter={activeFilter}
                showFilters={true}
                onSearchInput={handleSearch}
                loading={isLoading}
                showActions={false}
                searchInputProps={{ value: categoryState?.search }}
                SearchIcon={
                  <span className="material-symbols-outlined"> search </span>
                }
                showDateRange={false}
                handleClear={handleClearClick}
                extraFilters={
                  <div className="col-auto">
                    <button
                  className={`pro-btn pro-btn-outline pro-h-100 pro-items-center`}
                  onClick={() => setFilterShow(true)}
                  >
                    <span className="material-symbols-outlined">tune</span>
                    <span>Filter</span>
                  </button>
                  </div>
                }
              />
            <Table
              data={category?.data?.original?.data || []}
              uniqueID={"_id"}
              fields={tableFields}
              showCheckBox={
                hasEditPermission || hasDeletePermission ? true : false
              }
              SortIcon={<FaSort />}
              handleEdit={handleCategoryDataEditClick}
              editIcon={<span className="material-symbols-outlined">edit</span>}
              handleDelete={deleteCategoryDataClick}
              deleteIcon={
                <span className="material-symbols-outlined">delete</span>
              }
              handleSort={handleSort}
              getRow={getRow}
              loading={isFetching}
              perpage={categoryState.currentPageSize}
              assignable={false}
              multiSelect={false}
              clear={categoryState.clearSelection}
              editable={hasEditPermission ? true : false}
              deletable={hasDeletePermission ? true : false}
            />
            {category?.data?.original?.data?.length > 0 && (
              <Pagination
                currentPage={currentPage}
                totalPageCount={category?.data?.original?.last_page_number}
                onPageChange={handlePagination}
                options={paginationOptions}
                onActionChange={handlePageSize}
                center
              />
            )}
            </div>
            <ModalLayout
              centered
              show={showDeleteModal}
              handleClose={closeDeleteModal}
            >
              <div className="pro-m-5">
                <ConfirmationBox
                  title={`Are you sure you want to delete?`}
                  isRight={true}
                  cancelText={`Cancel`}
                  submitText={`Delete`}
                  cancelAction={closeDeleteModal}
                  submitAction={deleteCategory}
                >
                  ConfirmationBox
                </ConfirmationBox>
              </div>
            </ModalLayout>

            <OffCanvasLayout
              show={showCreateModal}
              handleClose={closeModal}
              title={`${
                isEditData ? "Update Category Details" : "Create Category"
              }`}
              closeIcon={
                <span className="material-symbols-outlined"> close </span>
              }
              backdrop={"static"}
            >
              <UpdateCategory
                activeId={activeId}
                refetch={refetch}
                isEditData={isEditData}
              />
            </OffCanvasLayout>

            <ModalLayout show={showImageModal} handleClose={closeModal}>
              <ImageCard data={imageData} handleClose={closeModal} />
            </ModalLayout>

            <OffCanvasLayout
              centered={true}
              show={filterShow}
              handleClose={() => {
                setFilterShow(false);
              }}
              title={"Filter"}
              closeIcon={
                <span className="material-symbols-outlined">close</span>
              }
            >
              <Filter setShowform={setFilterShow} refetch={refetch}/>
            </OffCanvasLayout>
          
        </>
   
  );
};

export default CategoryList;
